// extracted by mini-css-extract-plugin
export default {"loadingFlip":"loader_loadingFlip__hDxGU","lodercontatin":"loader_lodercontatin__DRcm-"};